module.exports = __webpack_public_path__ + "static/media/ni.ecbaae29.svg";